exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom_page{margin-top:15px}.custom_page .total{margin-right:10px}.custom_page .page_btn{color:#333333;background:#ffffff;border:1px solid #eeeeee;font-size:14px;padding-left:12px;padding-right:12px;min-width:30px;border-radius:2px;height:28px;vertical-align:top;cursor:pointer}.custom_page .el-pagination__jump{margin-left:10px;margin-right:10px}\n", ""]);

// exports
